import { SHELL } from "../shell/shell.const";

// DEVELOPMENTS
const DEVELOPMENTS = 'proyectos'
const DEVELOPMENT_OPEN = 'abiertos';
const DEVELOPMENT_CLOSED = 'cerrados';
const DEVELOPMENT_LIQUIDATED = 'liquidados';
const DEVELOPMENT_DASHBOARD = 'dashboard';
const DEVELOPMENT_INFO = 'detalle';
const DEVELOPMENT_INVEST = 'invertir';
const DEVELOPMENT_BUY_PART = 'inversion';
const DEVELOPMENT_SALE_PART = 'vender';
const DEVELOPMENT_BUY_PART_CONFIRM = 'confirmar';
const DEVELOPMENT_MARKET_BUY = 'comprar';
const DEVELOPMENT_RESALE_BUY = 'ms/reventa'
const DEVELOPMENT_RESALE_BUY_CONFIRM = 'ms/reventa/confirmacion'
const DEVELOPMENT_SELL_PART = 'vender-participaciones';

export const DEVELOPMENT_ROUTES = {
  DEVELOPMENTS,
  DEVELOPMENT_DASHBOARD,
  DEVELOPMENT_OPEN,
  DEVELOPMENT_CLOSED,
  DEVELOPMENT_LIQUIDATED,
  DEVELOPMENT_INFO,
  DEVELOPMENT_INVEST,
  DEVELOPMENT_BUY_PART,
  DEVELOPMENT_SALE_PART,
  DEVELOPMENT_BUY_PART_CONFIRM,
  DEVELOPMENT_MARKET_BUY,
  DEVELOPMENT_SELL_PART,
  DEVELOPMENT_RESALE_BUY,
  DEVELOPMENT_RESALE_BUY_CONFIRM,

  /** `/s/DEVELOPMENTos/info` */
  ROUTE_DEVELOPMENT_INFO: `/${SHELL}/${DEVELOPMENTS}/${DEVELOPMENT_INFO}`,
  /** `/s/DEVELOPMENTos/invertir` */
  ROUTE_DEVELOPMENT_INVEST: `/${SHELL}/${DEVELOPMENTS}/${DEVELOPMENT_INVEST}`,
  /** `/s/DEVELOPMENTos/inversion` */
  ROUTE_DEVELOPMENT_BUY_PART: `/${SHELL}/${DEVELOPMENTS}/${DEVELOPMENT_BUY_PART}`,
  /** `/s/DEVELOPMENTos/vender` */
  ROUTE_DEVELOPMENT_SALE_PART: `/${SHELL}/${DEVELOPMENTS}/${DEVELOPMENT_SALE_PART}`,
  /** `/s/DEVELOPMENTos/inversion` */
  ROUTE_DEVELOPMENT_MARKET_BUY: `/${SHELL}/${DEVELOPMENTS}/${DEVELOPMENT_MARKET_BUY}`,
  /** `/s/DEVELOPMENTos/confirmar` */
  ROUTE_DEVELOPMENT_BUY_PART_CONFIRM: `/${SHELL}/${DEVELOPMENTS}/${DEVELOPMENT_BUY_PART_CONFIRM}`,
  /** `/s/DEVELOPMENTos/abiertos` */
  ROUTE_DEVELOPMENTS_OPEN: `/${SHELL}/${DEVELOPMENTS}/${DEVELOPMENT_OPEN}`,
  /** `/s/DEVELOPMENTos/cerrados` */
  ROUTE_DEVELOPMENTS_CLOSED: `/${SHELL}/${DEVELOPMENTS}/${DEVELOPMENT_CLOSED}`,
  /** `/s/DEVELOPMENTos/liquidados` */
  ROUTE_DEVELOPMENTS_LIQUIDATED: `/${SHELL}/${DEVELOPMENTS}/${DEVELOPMENT_LIQUIDATED}`,
  /** `/s/DEVELOPMENTos/ms/compra` */
  ROUTE_DEVELOPMENT_RESALE_BUY: `/${SHELL}/${DEVELOPMENTS}/${DEVELOPMENT_RESALE_BUY}`,

  ROTUE_DEVELOPMENT_DASHBOARD: `/${SHELL}/${DEVELOPMENTS}/${DEVELOPMENT_DASHBOARD}`

}
